/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.0.0
 */
import { useEffect } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { logoutStartAction } from '../PageAuth/actions/authActions';

export const LogoutPage = (props: IDispatchProps) => {
    const { logout } = props;

    useEffect(() => {
        logout();
    }, [logout]);

    // We can show some info while logout processing
    return null;
};

export interface IDispatchProps {
    logout: () => void;
}

export const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    logout: () => dispatch(logoutStartAction()),
});

export default connect(null, mapDispatchToProps)(LogoutPage);
